<div class="wrapper">
    <!-- <div class="row table-toolbar">
        <div class="cal-xl-4 col-lg-4 col-md-12 col-sm-12">
            <h2>Screenshots</h2>
        </div>
    </div> -->
    <div class="row  table-toolbar">
        <div class="cal-xl-12 col-lg-12 col-md-12 col-sm-12">
            <form [formGroup]="AdvancedSearchForm" (ngSubmit)="AdvancedSearchFormSubmit()">
                <div class="row">
                    <div class="cal-xl-2 col-lg-3 col-md-12 col-sm-12" *ngIf="isShowOrganization">
                        <mat-form-field>
                            <mat-label>Organizations</mat-label>
                            <mat-select formControlName="org_id" (selectionChange)="organizationChange($event)">
                                <mat-option *ngFor="let organization of organizations;" [value]="organization?.org_id">{{organization?.name}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="cal-xl-2 col-lg-3 col-md-12 col-sm-12">
                        <!-- <mat-form-field>
                            <mat-label> User</mat-label>
                            <mat-select formControlName="user_id">
                                <mat-option *ngFor="let user of users;" [value]="user?.id | numberToStringConvert">
                                    <span>{{user?.name}}</span>
                                </mat-option>
                            </mat-select>
                            <mat-error *ngIf="AdvancedSearchFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
                        </mat-form-field> -->

                        <mat-form-field>
                            <mat-label>User</mat-label>
                            <input type="hidden" formControlName="user_id">
                            <input matInput placeholder="Search" [matAutocomplete]="auto" [formControl]="searchUserNameCtrl" [multiple]="true">
                            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displaySearchUserName">
                                <mat-option *ngFor="let user of users;" [value]="user">
                                    <span>{{user?.name}}</span>
                                </mat-option>
                            </mat-autocomplete>
                            <mat-error *ngIf="AdvancedSearchFormValidate?.user_id?.errors?.required">This field is required.</mat-error>
                        </mat-form-field>

                    </div>
                    <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <mat-form-field>
                            <mat-label> From Date</mat-label>
                            <input matInput [max]="fromMaxDate" formControlName="from_date" [min]="fromMinDate" (dateInput)="onFromDateChange($event)" [matDatepicker]="leave_from_date" (focus)="leave_from_date.open()">
                            <mat-datepicker-toggle matSuffix [for]="leave_from_date"></mat-datepicker-toggle>
                            <mat-datepicker #leave_from_date></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <mat-form-field>
                            <mat-label> To Date</mat-label>
                            <input matInput [max]="toMaxDate" formControlName="to_date" [min]="toMinDate" (dateInput)="onToDateChange($event)" [matDatepicker]="leave_to_date" (focus)="leave_to_date.open()">
                            <mat-datepicker-toggle matSuffix [for]="leave_to_date"></mat-datepicker-toggle>
                            <mat-datepicker #leave_to_date></mat-datepicker>
                        </mat-form-field>
                    </div>
                    <div class="cal-xl-2 col-lg-2 col-md-12 col-sm-12">
                        <button type="submit" mat-raised-button class="btn-int-blue forSearch">Search </button>
                    </div>
                </div>
            </form>
        </div>
        <!-- <div class="cal-xl-6 col-lg-12 col-md-12 col-sm-12" *ngIf="this.screenshotsDataSource?.filteredData?.length > 0">
            <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
        </div> -->
    </div>

    <mat-card>
        <div class="row table-toolbar" *ngIf="this.screenshotsDataSource?.filteredData?.length > 0;else noRecords;">
            <div class="cal-xl-6 col-lg-12 col-md-12 col-sm-12" *ngIf="this.screenshotsDataSource?.filteredData?.length > 0">
                <mat-paginator #paginator [length]="page_length" [pageSize]="items_per_page" [pageSizeOptions]="PAGE_SIZE_OPTIONS_DATA" (page)="handlePage($event)"></mat-paginator>
            </div>
            <div class="col-12">
                <div class="row">
                    <div class="col-6" *ngFor="let screenshot of screenshotsDataSource?.filteredData;">
                        <app-screenshot-view [SceenshotDataSource]="screenshot" (refreshData)="refreshData($event)">
                        </app-screenshot-view>
                    </div>
                </div>
            </div>
        </div>
        <ng-template #noRecords>
            <div class="row forNoRecords">
                <h3 class="table-no-date"> No Record found</h3>
            </div>
        </ng-template>
    </mat-card>
</div>